import { functions } from './firebase/config';
import { httpsCallable } from 'firebase/functions';

export interface PlanAssistantMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface PlanAssistantResponse {
  response: string;
  conversationHistory: PlanAssistantMessage[];
  planTier?: 'standard' | 'premium' | 'corporate';
}

class SubscriptionPlanAssistantService {
  async send(message: string, conversationHistory: PlanAssistantMessage[] = []): Promise<PlanAssistantResponse> {
    const callable = httpsCallable(functions, 'subscriptionPlanAssistant');
    const result = await callable({ message, conversationHistory });
    return result.data as PlanAssistantResponse;
  }
}

export const subscriptionPlanAssistantService = new SubscriptionPlanAssistantService();
export default subscriptionPlanAssistantService;
